export default {
	'salary-details': 'تفاصيل الراتب',
	'received-salary': 'تلقى الراتب',
	'receiving-date': 'تاريخ الاستلام',
	'base-salary': 'أساس الراتب',
	rewards: 'مكافآت',
	rebates: 'الحسومات',
	transportation: 'المواصلات',
	'liability-compensation': 'بدل المسؤولية',
	'living-expenses': 'نفقات المعيشة',
	communications: 'الاتصالات',

	'add-new-vacation-request': 'أضف طلب عطلة جديد',
	'vacation-type': {
		'sick-leave': 'إجازة مرضية',
		'unpaid-leave': 'إجازة غير مدفوعة',
		'paid-leave': 'إجازة مدفوعة',
	},
	'the-request-is-sent': 'تم إرسال الطلب',

	'add-new-administrative-request': 'إضافة طلب إداري جديد',
	'administrative-type': {
		'administrative-day': 'يوم إداري',
		'half-administrative-day': 'نصف يوم إداري',
	},

	administrative: 'إداري',
	leaves: 'إجازات',
	salary: 'مرتب',
	visits: 'الزيارات',
	'financial-target': 'الهدف المالي',
	'today-visits': 'زيارات اليوم',
	'today-income': 'الدخل اليوم',
	'you-have-completed-$-out-of-$': 'قمت بإكمال {num1} من {num2}',
	'last-rating': 'التقييم الأخير',
	'leaves-remaining': 'الأوراق المتبقية'
}